import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ConstantsProvider } from './constant/constantProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ConstantsProvider>
        <App />
    </ConstantsProvider>
);

reportWebVitals();
